const mapDiv = document.getElementById('map');

if(mapDiv) {
    const imgMarker = `${markerPath}MapIcon.svg`;
    const map = L.map('map', {
        dragging: !L.Browser.mobile,
        tap: !L.Browser.mobile,
        scrollWheelZoom: false
    }).setView([30.404573, -97.705494], 11);

    let mapIcon;
    if(window.innerWidth > 680) {
        mapIcon = L.icon({
            iconUrl: imgMarker,
            iconSize:     [90, 95], // size of the icon
            iconAnchor:   [90, 95], // point of the icon which will correspond to marker's location
            popupAnchor:  [180, 10] // point from which the popup should open relative to the iconAnchor
        });
    } else {
        mapIcon = L.icon({
            iconUrl: imgMarker,
            iconSize:     [90, 95],
            iconAnchor:   [40, 95],
            popupAnchor:  [10, 140]
        });
    }

    L.tileLayer('https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png?api_key=a2c8d7c2-8c5e-49db-a7ee-3741bad4b5c5').addTo(map);
    //L.tileLayer('https://{s}.tile.jawg.io/jawg-light/{z}/{x}/{y}{r}.png?access-token=4ekqaORfcauLTcOLPKdIq4G58OGl7XnytjLawW4Irq8JNsYLM6fF0I8NEdyKxX6r').addTo(map);
    //L.tileLayer('https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png').addTo(map);

    L.marker([30.404573, -97.705494], { icon: mapIcon }).addTo(map)
        .bindPopup(
            `<p class="tool-h">HEADQUARTERS</p>
                <p class="tool-b">11815 Alterra Pkwy, Floor 15</br>
                Austin, TX 78758
                </p>`
        )
        .openPopup();
}
